import GeneralNotes from '@/pages/general-notes/GeneralNotes';

export default GeneralNotes;
